import { REDUCER } from '../reducers/reducersConst';

/**
 * BOOK REDUCER
 */
let defaultBookState = {
  books: null,
  book: {},
  bookToRemove: null,
  openUnit: -1,
  newLessonUnitId: null,
  openNewUnit: -1,
  deleteActivityReveal: null,
  unitEdition: -1,
  selectedResource: {},
  selectedUnit: {},
  isLinkLessonModalOpen: false,
  bookToReDownload: null,
  synchronizedClassrooms: [],
  desynchronizeActivityContext: null,
  activityLinkChanged: null,
  uploadContentStatus: {
    percentCompleted: 0,
    isUploading: false,
    cancelUpload: null
  }
};

export let book = (state = defaultBookState, action) => {
  switch (action.type) {
    case REDUCER.BOOK.SET_BOOKS_DATA:
      return {
        ...state,
        books: JSON.parse(JSON.stringify(action.books))
      };
    case REDUCER.BOOK.SET_BOOK_INFO:
      return {
        ...state,
        book: JSON.parse(JSON.stringify(action.book))
      };
    case REDUCER.BOOK.SET_NEW_LESSON_UNIT:
      return {
        ...state,
        newLessonUnitIdRef: action.unitIdRef
      };
    case REDUCER.BOOK.SET_NEW_LESSON_UNIT_ID:
      return {
        ...state,
        newLessonUnitId: action.unitId
      };
    case REDUCER.BOOK.SET_OPEN_UNIT:
      return {
        ...state,
        openUnit: action.unit
      };
    case REDUCER.BOOK.SET_SELECTED_RESOURCE:
      return {
        ...state,
        selectedResource: action.resource
      };
    case REDUCER.BOOK.SET_SELECTED_UNIT:
      return {
        ...state,
        selectedUnit: action.selectedUnit
      };
    case REDUCER.BOOK.SET_OPEN_NEW_UNIT:
      return {
        ...state,
        openNewUnit: action.position
      };
    case REDUCER.BOOK.SET_ACTIVITY_DELETE_DATA:
      return {
        ...state,
        deleteActivityReveal: action.activity
      };
    case REDUCER.BOOK.SET_UNIT_EDITION:
      return {
        ...state,
        unitEdition: action.unitEdition
      };
    case REDUCER.BOOK.SET_REMOVE_BOOK_INFO:
      return {
        ...state,
        bookToRemove: action.bookToRemove
      };
    case REDUCER.BOOK.SET_IS_LINK_LESSON_MODAL_OPEN:
      return {
        ...state,
        isLinkLessonModalOpen: action.isLinkLessonModalOpen
      };
    case REDUCER.BOOK.SET_IS_AUTO_EXEC_MODAL_OPEN:
      return {
        ...state,
        isAutoExecLessonModalOpen: action.isAutoExecLessonModalOpen
      };
    case REDUCER.BOOK.SET_RE_DOWNLOAD_BOOK_INFO:
      return {
        ...state,
        bookToReDownload: action.bookToReDownload
      };
    case REDUCER.BOOK.SET_SYNCHRONIZED_CLASSROOMS:
      return {
        ...state,
        synchronizedClassrooms: action.synchronizedClassrooms
      };
    case REDUCER.BOOK.SET_DESYNCHRONIZE_ACTIVITY_CONTEXT:
      return {
        ...state,
        desynchronizeActivityContext: action.desynchronizeActivityContext
      };
    case REDUCER.BOOK.SET_ACTIVITY_LINK_CHANGED:
      return {
        ...state,
        activityLinkChanged: action.activityLinkChanged
      };
    case REDUCER.BOOK.SET_UPLOAD_CONTENT_STATUS:
      return {
        ...state,
        uploadContentStatus: action.uploadContentStatus
      };
    case REDUCER.BOOK.SET_COPY_REVEAL:
      return {
        ...state,
        copyReveal: action.copyReveal
      };
    default:
      return state;
  }
};
